<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">

  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormularioEstado" name="nomFormularioEstado">
    <div class="grid form-group">
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'SEGUROCOBERTURAS.LBL_COBERTURAS' | translate }}</label>

          <p-dropdown disableTab  id="idListaCobertura" name="idListaCobertura" [options]="lisCoberturas"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                       formControlName="idListaCobertura"
                      filter="filter"
                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
          ></p-dropdown>

          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idListaCobertura.invalid">
            {{ 'SEGUROCOBERTURAS.LBL_COBERTURAS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>

        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'SEGUROCOBERTURAS.LBL_COBERTURABILLETERA' | translate }}</label>
          <input type="text" pInputText id="nombre"
                 name="nombreCoberturaBilletera"
                 autocomplete="off"
                 formControlName="nombreCoberturaBilletera"
                 capitalize-reactive
                 [maxlength]="20"
          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombreCoberturaBilletera.invalid">
            {{ 'SEGUROCOBERTURAS.LBL_COBERTURABILLETERA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <div *ngIf="f.idIcono.value && !subAdjunto" class="btn-group" role="group" style="display: block;">
            <label class="btn btn-default" style="max-width: 87%; overflow: hidden;">
              <img [src]="imagen" width="50" height="50" alt="imagen"/>
              {{f.nombreArchivo.value}}
            </label>
            <a class="btn btn-danger" (click)="eliminarAdjunto()" style="padding: 3px; border-radius: 5px;">
              <i class="fa fa-times" aria-hidden="true"></i>
            </a>
          </div>
          <p-fileUpload name="file" url="{{svcThUrl}}" [auto]="false" class="upload-avatar"
                        chooseLabel="{{'SEGURO.LBL_ADJUNTAR' | translate}}"
                        #adjunto
                        (onBeforeUpload)="onBeforeSend($event)" mode="basic"
                        (onValidSelect)="onSelect($event, $event.files)"
                        (onUpload)="uploadingOk($event)" accept="image/svg+xml"
                        invalidFileTypeMessageSummary="{0} {{'LBL_FILETIPO' | translate}}."
                        invalidFileTypeMessageDetail="{{'SEGURO.LBL_FILETIPOES' | translate}}"
                        fSize
          ></p-fileUpload>
          <div class="p-message p-messages-error p-corner-all"
               *ngIf="submitted && f.idIcono.invalid">
            {{ 'SEGURO.LBL_ADJUNTAR' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
          <div *ngIf="((f.idIcono.value == null))">
            {{ 'LBL_TAMANOMAXIMO' | translate}}: {{fsize / 1000000}} MB <br>
            {{ 'LBL_TIPOARCHIVO' | translate}}: {{'SEGURO.FTYPE' | translate }}
          </div>
        </div>
      </div>

    </div>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <div *ngIf="!guardando">
          <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
          <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                  type="submit"
                  pButton></button>
        </div>
        <div *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
          <span>{{'LBL_GUARDANDO' | translate }}</span>
        </div>
      </div>
    </div>
  </form>

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" #dt
               [value]="lisSegurosCoberturas" selectionMode="single" dataKey="nombre"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.nombreCobertura}}</td>
            <td>{{row.nombreCoberturaBilletera}}</td>
            <td class="text-center"><img *ngIf="row.imagen" [src]="row.imagen" width="40" height="40" alt="row.imagen"/></td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button
                  type="button"
                  class="p-button p-button-success btn"
                  icon="fa fa-trash"
                  data-toggle="tooltip"
                  title="{{ 'BTN_ELIMINAR' | translate }}"
                  pButton
                  (click)="eliminarSegurosCoberturas(row, index)"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>




</div>
<p-confirmDialog #cd key="eliminar">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

